import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";

const Item = React.memo(({ label, value }) => (
  <div className={styles.sidebarItem}>
    <div
      className={styles.sidebarLabel}
      data-testid="waiting-room-sidebar-item-label"
    >
      {label}
    </div>
    <div
      className={styles.sidebarValue}
      data-testid="waiting-room-sidebar-item-value"
    >
      {value}
    </div>
  </div>
));

Item.displayName = "Item";

Item.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
};

export default Item;
